
/*
* 用户申请
*/

<template>
  <div class="hbn-container" id="userInfo">
    <div class="search-form">
      <el-row :gutter="24">
        <el-col :span="18">
          <el-form
            ref="form"
            :model="form"
            label-width="80px"
            label-position="right"
            size="mini"
          >
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="手机号">
                  <el-input
                    id="queryModelName"
                    v-model="PageQuery.queryModel.phone"
                    placeholder="手机号"
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <el-button size="mini" class="hbn-button-serach" @click="seach"
              >查找</el-button
            >
            <span class="control-collapse" @click="show = !show">{{
              show ? "收起" : "展开"
            }}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </div>

    <div class="hbn-table-screen">
      <div class="operation">
        <!-- <el-button
          class="custom-button"
          type="primary"
          :icon="Search"
          @click="add"
        >
          <i class="el-icon-circle-plus-outline custom-icon"></i>
          <span>新增</span>
        </el-button> -->

      </div>

      <div class="custom-table-layer">
        <div style="margin-bottom: 13px">
          <vxe-table
            :data="DataList"
            round
            border
            height="388"
            class="mytable-scrollbar"
            style="width: 100%"
            :highlight-current-row="true"
            @current-change="handleCurrentChange"
            @checkbox-change="handleSelectionChange"
            ref="multipleTable"
            highlight-hover-row
            highlight-hover-column
            highlight-current-column
            show-overflow="tooltip"
            empty-text="没有更多数据了！"
            resizable
            stripe
          >
            <vxe-table-column
              fixed="left"
              type="checkbox"
              width="40"
            ></vxe-table-column>
            <vxe-table-column
              fixed="left"
              type="seq"
              width="55"
              title="序号"
              align="center"
            ></vxe-table-column>

            <template v-for="(item, key) in UserPermissionList" :key="key">
              <vxe-table-column
                :field="item.prop"
                :title="item.label"
                :width="item.width"
                align="center"
                v-if="item.isShow"
                show-overflow-tooltip
                :sortable="item.order"
                :class-name="JSON.stringify(item)"
                :formatter="formatterData"
              />
            </template>

            <vxe-table-column
              width="150"
              fixed="right"
              title="操作"
              align="center"
            >
              <template #default="{ rowIndex }">

                <el-button
                  type="text"
                  size="small"
                  v-show="DataList[rowIndex].status==0"
                  @click="handleClick(rowIndex, 1)"
                  >同意</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  v-show="DataList[rowIndex].status==0"
                  @click="handleClick(rowIndex, 2)"
                  >拒绝</el-button
                >

              </template>
            </vxe-table-column>
          </vxe-table>
        </div>

        <div class="pagination">
          <vxe-pager
            perfect
            size="mini"
            :current-page="PageQuery.pageindex"
            :page-size="PageQuery.PageSize"
            :page-sizes="[20, 50, 100, 500]"
            :total="total"
            :pager-count="5"
            :layouts="[
              'PrevJump',
              'PrevPage',
              'JumpNumber',
              'NextPage',
              'NextJump',
              'FullJump',
              'Sizes',
              'Total',
            ]"
            @page-change="handlePageChange"
          >
            <!-- <template #left>
                    <span class="page-left">
                        <span>已选中 {{ checkendSum }}</span>
                        <span class="clear" @click.prevent="$refs.multipleTable.clearCheckboxRow()">清空</span>
                    </span>
                </template> -->
          </vxe-pager>
          <!-- </div> -->
        </div>
      </div>
    </div>
    <excel
      ref="industrialUnitExcel"
      :importurl="importurl"
      fileName="所属行业.xlsx"
      :dialogVisible="UpLoaddialogVisible"
      @close-dialog="closeUpDialog"
      @error="error"
      @success="success"
    ></excel>
  </div>
</template>

<script>
import { Search, Delete } from "@element-plus/icons";
import { UserPermissionList } from "@/assets/apiData/Company/UserPermissionList";
import { GetDataUserPermissionListByPageQuery, ModifyStatus } from "@api/Company/ApiUserPermission";

// import XEUtils from "xe-utils";
import excel from "@comp/ExcelHelper/importExcel";
import Enumerable from "linq";
import { dateFormat } from "@/util/utils.js";

export default {
  data() {
    return {
      PageQuery: {
        queryModel: {
          name: "",
        },
        pageindex: 1,
        PageSize: 20,
      },
      total: 0,
      multipleSelection: [],
      dialogVisible: false,
      UpLoaddialogVisible: false,
      seldata: {
        dialogGUID: "",
        dialogtype: "",
      },
      show: false,
      Industry: {
        CodeID: "",
        Name: "",
      },
      UserPermissionList: [],
      DataList: [],
      url: "",
      importurl: "/api/IndustrialUnit/ImportExcel?tabname=Industry",
    };
  },
  components: {
    excel,
    Search,
  },
  computed: {
    checkendSum() {
      return this.multipleSelection.length;
    },
  },
  methods: {
    error() {},
    success() {},
    closeUpDialog() {
      this.UpLoaddialogVisible = false;
    },
    importExcel() {
      this.UpLoaddialogVisible = true;
    },
    export2Excel() {
      const v = this;
      require.ensure([], () => {
        const { export_json_to_excel } = require("@/excel/Export2Excel.js"); //必须使用绝对路径

        const tHeader = [
          ...Enumerable.from(v.UserPermissionList)
            .select((item) => {
              return item.label;
            })
            .toArray(),
        ]; // 标题
        const filterVal = [
          ...Enumerable.from(v.UserPermissionList)
            .select((item) => {
              return item.prop;
            })
            .toArray(),
        ]; // 导出的字段名
        const list = v.DataList;
        const data = v.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, `所属行业`);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    handleClick(index, type) {
      var _this = this;
      ModifyStatus(_this.DataList[index].id,type).then(function (data) {
        if (data) {
          _this.$message.success("操作成功");
          _this.DataList[index].status=type;
        }
      });
    },
    formatterData:function({cellValue, row, column}){
      let head = JSON.parse(column.className);
      let format = head.format;
      switch (format) {
        case "datetime":
          cellValue = dateFormat("YYYY-mm-dd HH:MM:SS",cellValue);
          break;
        case "checkbox":
          cellValue = cellValue == "1" ? "是" : "否";
          break;
        case "status":
          cellValue = cellValue == "0" ? "已提交" :cellValue == "1" ? "已同意":"已拒绝";
          break;
      }
      return cellValue;
    },
    UserPermissionEdit(index, type) {
      var _this = this;
      if (type == "Delete") {
        DeleteUserPermission(this.DataList[index].id).then(function (data) {
          if (data) {
            _this.$message.success("删除成功");
            _this.PageQuery.pageindex = 1;
            _this.GetData();
          }
        });
      } else {
        this.dialogVisible = true;
        var id = 0;
        if (type != "Add") id = _this.DataList[index].id;
        this.$refs.UserPermissionEdit.loadDataById(id, type);
      }
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    //选中事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    add() {
      this.UserPermissionEdit(-1, "Add");
    },
    seach() {
      this.PageQuery.pageindex = 1;
      this.GetData();
    },

    handleSizeChange(val) {
      //分页
    },
    handlePageChange({ currentPage, pageSize }) {
      if (this.PageQuery.PageSize != pageSize) {
        this.PageQuery.pageindex = 1; //说明更改了每页展示条数，要从第一页进行展示
        this.PageQuery.PageSize = pageSize;
      } else {
        this.PageQuery.pageindex = currentPage;
      }
      this.GetData();
    },
    handleCurrentChange(val) {
      console.log(val);
      this.GetData();
    },
    SearchDataInfo() {},
    GetData() {
      const _this = this;
      this.SearchDataInfo();
      try {
        GetDataUserPermissionListByPageQuery(JSON.stringify(this.PageQuery)).then(function (
          data
        ) {
          _this.DataList = data.entities;
          _this.total = data.totalCount;
        });
      } catch (e) {
        console.log(e);
      }
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    handleCancel() {
      this.dialogVisible = false;
    },
    handleConfirm(val) {
      this.dialogVisible = false;
      this.PageQuery.pageindex = 1;
      this.GetData();
    },
  },
  created() {
    this.UserPermissionList = UserPermissionList;
    this.GetData();
    //console.log(UserPermissionList);
  },
};
</script>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/reset-input";
.custom-table-header > th {
  background: #dfdfdf !important;
}

.custom-table-header > th > .cell {
  font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
  font-weight: 500;
  color: #868686 !important;
  line-height: 22px;
}

.custom-table-layer ::v-deep .el-table .cell {
  color: #32383d;
}
.el-table .cell {
  color: #32383d;
}

.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
  display: none;
}
.custom-table-layer .el-pagination.is-background .btn-prev,
.custom-table-layer .el-pagination.is-background .btn-next,
.custom-table-layer .el-pagination.is-background .el-pager li {
  border: 1px solid #acb5bd;
  width: 32px;
  height: 32px;
  line-height: 32px;
  background-color: #fff;
}
</style>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/hbn-base-model";
#userInfo {
}
</style>
<style scoped>
</style>
